/**
 * External dependencies.
 */
import Link from "next/link";
import { useRouter } from "next/router";
import { Trans } from "@lingui/macro";

/**
 * Internal dependencies
 */
import IconFacebook from "../../assets/images/svg/share-facebook.svg";
import IconTwitter from "../../assets/images/svg/share-twitter.svg";
import IconPinterest from "../../assets/images/svg/share-pinterest.svg";

const Share = () => {
  const router = useRouter();
  const pageUrl = `https://digifist.com${router.asPath}`;

  return (
    <div className="container">
      <div className="share">
        <p>
          <Trans>Share</Trans>
        </p>

        <Link
          href={`https://www.facebook.com/sharer/sharer.php?u=${pageUrl}`}
          passHref={true}
          target="_blank"
        >
          <IconFacebook />
        </Link>
        <Link
          href={`https://twitter.com/intent/tweet?url=${pageUrl}&text=`}
          passHref={true}
          target="_blank"
        >
          <IconTwitter />
        </Link>
        <Link
          href={`https://pinterest.com/pin/create/button/?url=${pageUrl}&media=&description=`}
          passHref={true}
          target="_blank"
        >
          <IconPinterest />
        </Link>
      </div>
    </div>
  );
};

export default Share;
